import { render, staticRenderFns } from "./CategorySkeleton.vue?vue&type=template&id=2e755909&scoped=true&"
var script = {}
import style0 from "./CategorySkeleton.vue?vue&type=style&index=0&id=2e755909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e755909",
  null
  
)

export default component.exports